<script>
export default {
  name: 'LinkedinRiskAcceptanceModal',
  props: {
    show: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
  },
  emits: ['confirm', 'cancel'],
  data() {
    return { accepted: false };
  },
  watch: {
    show(value) {
      if (!value) this.accepted = false;
    },
  },
  methods: {
    onConfirm() {
      if (!this.accepted || this.isLoading) return;
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal :show="show" :on-close="onCancel">
    <woot-modal-header
      :header-title="$t('INBOX_MGMT.ADD.LINKEDIN.RISK_MODAL.TITLE')"
    />
    <div class="px-8 pb-8">
      <p class="text-sm text-slate-700 dark:text-slate-200">
        {{ $t('INBOX_MGMT.ADD.LINKEDIN.RISK_MODAL.BODY') }}
      </p>
      <label class="flex items-start gap-2 mt-4 text-sm cursor-pointer">
        <input
          v-model="accepted"
          type="checkbox"
          class="mt-1"
          data-test-id="linkedin-risk-checkbox"
        />
        <span>{{ $t('INBOX_MGMT.ADD.LINKEDIN.RISK_MODAL.CHECKBOX') }}</span>
      </label>
      <div class="flex justify-end gap-2 mt-6">
        <woot-button
          variant="clear"
          color-scheme="secondary"
          data-test-id="linkedin-risk-cancel"
          @click="onCancel"
        >
          {{ $t('INBOX_MGMT.ADD.LINKEDIN.RISK_MODAL.CANCEL') }}
        </woot-button>
        <woot-button
          :disabled="!accepted"
          :is-loading="isLoading"
          data-test-id="linkedin-risk-confirm"
          @click="onConfirm"
        >
          {{ $t('INBOX_MGMT.ADD.LINKEDIN.RISK_MODAL.CONFIRM') }}
        </woot-button>
      </div>
    </div>
  </woot-modal>
</template>
